// extracted by mini-css-extract-plugin
export default {"pageContainer":"LanguageSelectionPage_pageContainer__lqatl","languageList":"LanguageSelectionPage_languageList__AEjD8","checkIcon":"LanguageSelectionPage_checkIcon__9SNAQ"};